import React, { useEffect, useState } from 'react';
import SEO from '../components/SEO';
import Header from '../components/header';
import Hero from '../components/hero';
import Testimonials from '../components/testimonials';
import Value from '../components/value';
import Proces from '../components/proces';
import ArtikelSektion from '../components/artikelsektion';
import ForsideFAQ from '../components/ForsideFAQ';
import Footer from '../components/footer';

// Animated Hero Title Component
const AnimatedHeroTitle = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const rotatingWords = [
    "dine kunder",
    "salg",
    "brugervenlighed",
    "konvertering",
    "SEO",
    "hastighed",
    "tilgængelighed",
    "vækst"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % rotatingWords.length);
    }, 3000); // Skift hvert 3. sekund

    return () => clearInterval(interval);
  }, []);

  return (
    <h1 className="hero-section__title">
      Få en hjemmeside der har fokus på{' '}
      <span className="hero-section__highlight hero-section__rotating-text" key={currentIndex}>
        {rotatingWords[currentIndex]}
      </span>
    </h1>
  );
};

const Home = () => {
  return (
    <div>
      <SEO 
        title="Parla Branding | Hjemmesider der er en Investering, ikke en Udgift"
        description="Er jeres nuværende hjemmeside et aktiv, der skaber kunder? Vi er specialister i at bygge professionelle, skræddersyede hjemmesider, der leverer målbare forretningsresultater."
        keywords="hjemmeside investering, professionel hjemmeside, skræddersyede hjemmesider, hjemmeside der konverterer, webdesign til forretning, hjemmeside ROI"
        url="https://parlabranding.dk"
        type="website"
        canonicalUrl="https://www.parlabranding.dk"
        isService={true}
        serviceData={{
          name: "Professionelle Hjemmesider og Webdesign",
          description: "Vi designer og udvikler professionelle hjemmesider for danske virksomheder med fokus på konvertering og synlighed",
          price: "10000",
          priceRange: "10000-50000"
        }}
      />
      <Header />
      <Hero customTitle={<AnimatedHeroTitle />} />
      <Testimonials />
      <Value />
      <Proces />
      <ArtikelSektion />
      <ForsideFAQ />
      <Footer />
    </div>
  );
};

export default Home; 